<template>
  <div class="filter-list-select">
    <FilterListNodeCheck
      :leaves="leaves || []"
      :selected-leaves="selectedLeaves"
      :parent-rank="0"
      :is-expanded="true"
      :locale="locale"
      :default-locale="defaultLocale"
      @leaf-checked="toggleSelection"
    />
  </div>
</template>

<script lang="ts" setup>
import FilterListNodeCheck from "./FilterListNodeCheck.vue";

const props = defineProps({
  locale: { type: String, default: "fr" },
  defaultLocale: { type: String, default: "" },
  referenceType: { type: String, default: "" },
  componentKey: { type: String, default: "" },
  leaves: { type: Array, required: true },
  selectedLeaves: { type: Array, required: true },
});

const emit = defineEmits(["update:selectedLeaves"]);

function toggleSelection(event: Event) {
  emit("update:selectedLeaves", { referenceType: props.referenceType, ...event });
}
</script>
<style>
.filter-list-select {
  height: auto;
  max-height: 15em;
  overflow-y: scroll;
}
</style>
